import { ScrollToTop } from '@components/common/ScrollToTop.jsx'
import { useScrollStore } from '@store/common/useScrollStore.js'
import { Footer } from '@templates/layout/Footer.jsx'
import clsx from 'clsx'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { getFooterExchanges } from '@constants/footerExchanges.js'

const FOOTER_HIDDEN_PATHS = ['/search', '/news']
const CONTENT_MIN_HEIGHT =
  'min-h-[calc(100dvh_-_env(safe-area-inset-top)_-_env(safe-area-inset-bottom))]'

const FOOTER_EXCHANGES = getFooterExchanges(__APP_TARGET__)

export const MainLayout = () => {
  const { pathname } = useLocation()
  const showFooter = !FOOTER_HIDDEN_PATHS.includes(pathname)

  useEffect(() => {
    const handleScroll = () => {
      const y = document.body.scrollTop
      useScrollStore.getState().setLatestScrollY(y)
    }

    document.body.addEventListener('scroll', handleScroll)

    return () => {
      document.body.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <section className={clsx('flex flex-col', CONTENT_MIN_HEIGHT)}>
      <main className="flex flex-grow flex-col">
        <ScrollToTop />
        <Outlet />
      </main>
      {showFooter && <Footer exchanges={FOOTER_EXCHANGES} />}
    </section>
  )
}
